<template>
  <div class="ml-5">
    <div
      v-for="type in typesList"
      :key="type.value"
      class="row"
    >
      <b-form-checkbox
        v-model="type.isSelected"
        class="col-6"
        size="lg"
        switch
        @change="handleChange"
      >
        {{ type.title }}
      </b-form-checkbox>
      <b-form-group
        class="col-6"
        :label="`${$t('auction.count')}:`"
        :description="`${$t('common.max')} ${type.capacity}`"
        label-cols="9"
        label-align="right"
      >
        <b-form-input
          v-model="type.places"
          type="number"
          number
          min="0"
          :disabled="!type.isSelected"
          :max="type.capacity"
          :formatter="(value) => placesFormatter(type.capacity, value)"
          :lazy-formatter="true"
          @change="handleChange"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectAuctions',
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    selected: {
      type: Array,
      default() {
        return []
      },
    },
    auctionTypes: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      typesList: [],
    }
  },

  watch: {
    auctionTypes: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.typesList = newVal.map((type) => {
          return {
            ...type,
            places: null,
            isSelected: false,
          }
        })
      },
    },

    selected: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.typesList = this.typesList.map(type => {
          type.isSelected = newVal.some(val => val.promotionType.name === type.value)
          return type
        })
      },
    },
  },
  methods: {
    handleChange() {
      const res = []
      this.typesList.forEach(type => {
        if (type.isSelected) {
          res.push({
            places: type.places,
            promotionType: {
              name: type.value,
              capacity: type.capacity,
            },
          })
        }
      })

      this.$emit('change', res)
    },

    placesFormatter(max, value) {
      const res = Math.floor(value)
      return res > max ? max : res
    },
  },
}
</script>
